import {Component, Vue} from 'vue-property-decorator';

@Component
export default class DebounceMixin extends Vue {
  protected timer = 0;
  protected timeout = 500;

  protected debounce(callback: Function, timeout = 0) {
    clearTimeout(this.timer);
    this.timer = setTimeout(callback, timeout || this.timeout);
  }

  protected debounceFetch() {
    // @ts-ignore
    this.debounce(this.fetch);
  }
}
